function debounce(e, t) {
  let i;
  return (...s) => {
    clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
  };
}
var dispatchCustomEvent = function e(t) {
  var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    s = new CustomEvent(t, i ? { detail: i } : null);
  document.dispatchEvent(s);
};
if (
  ((window.recentlyViewedIds = []), !customElements.get("quantity-selector"))
) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.input = this.querySelector(".qty")),
        (this.step = this.input.getAttribute("step")),
        (this.changeEvent = new Event("change", { bubbles: !0 })),
        (this.subtract = this.querySelector(".minus")),
        (this.add = this.querySelector(".plus")),
        this.subtract.addEventListener("click", () =>
          this.change_quantity(-1 * this.step)
        ),
        this.add.addEventListener("click", () =>
          this.change_quantity(1 * this.step)
        );
    }
    connectedCallback() {
      this.classList.add("buttons_added"), this.validateQtyRules();
    }
    change_quantity(e) {
      let t = Number(this.input.value);
      isNaN(t) && (t = 1),
        !(
          this.input.getAttribute("min") > t + e ||
          (this.input.getAttribute("max") &&
            this.input.getAttribute("max") < t + e)
        ) &&
          ((t += e),
          (t = Math.max(t, 1)),
          (this.input.value = t),
          this.input.dispatchEvent(this.changeEvent),
          this.validateQtyRules());
    }
    validateQtyRules() {
      let e = parseInt(this.input.value);
      if (this.input.min) {
        let t = parseInt(this.input.min);
        this.subtract.classList.toggle("disabled", e <= t);
      }
      if (this.input.max) {
        let i = parseInt(this.input.max);
        this.add.classList.toggle("disabled", e >= i);
      }
    }
  }
  customElements.define("quantity-selector", e);
}
class ArrowSubMenu {
  constructor(e) {
    (this.submenu = e.parentNode.querySelector(".sub-menu")),
      (this.arrow = e),
      e.addEventListener("click", (e) => this.toggle_submenu(e));
  }
  toggle_submenu(e) {
    e.preventDefault();
    let t = this.submenu;
    t.classList.contains("active")
      ? (t.classList.remove("active"), this.arrow.blur())
      : t.classList.add("active");
  }
}
let arrows = document.querySelectorAll(".thb-arrow");
if (
  (arrows.forEach((e) => {
    new ArrowSubMenu(e);
  }),
  !customElements.get("product-card"))
) {
  class t extends HTMLElement {
    constructor() {
      super(),
        (this.swatches = this.querySelector(".product-card-swatches")),
        (this.image = this.querySelector(
          ".product-featured-image-link .product-primary-image"
        )),
        (this.additional_images = this.querySelectorAll(
          ".product-secondary-image"
        )),
        (this.additional_images_nav = this.querySelectorAll(
          ".product-secondary-images-nav li"
        )),
        (this.quick_add = this.querySelector(
          ".product-card--add-to-cart-button-simple"
        )),
        (this.size_options = this.querySelector(".product-card-sizes"));
    }
    connectedCallback() {
      this.swatches && this.enableSwatches(this.swatches, this.image),
        this.additional_images && this.enableAdditionalImages(),
        this.quick_add && this.enableQuickAdd(),
        this.size_options && this.enableSizeOptions();
    }
    enableAdditionalImages() {
      let e = this.additional_images.length,
        t = this.additional_images,
        i = this.additional_images_nav,
        s = this.querySelector(".product-featured-image-link"),
        a = function (s) {
          let a = s.offsetX,
            n,
            r = Math.floor((a / this.getBoundingClientRect().width) * e),
            o = t[r];
          t.forEach((e, t) => {
            e.classList.contains("hover") &&
              (e.classList.remove("hover"),
              i.length && i[t].classList.remove("active"));
          }),
            o &&
              !o.classList.contains("hover") &&
              (o.classList.add("hover"),
              i.length && i[r].classList.add("active"));
        },
        n = function (e) {
          t.forEach((e, t) => {
            e.classList.remove("hover"),
              i.length && i[t].classList.remove("active");
          });
        };
      s &&
        (s.addEventListener("touchstart", a, { passive: !0 }),
        s.addEventListener("touchmove", a, { passive: !0 }),
        s.addEventListener("touchend", n, { passive: !0 }),
        s.addEventListener("mouseenter", a, { passive: !0 }),
        s.addEventListener("mousemove", a, { passive: !0 }),
        s.addEventListener("mouseleave", n, { passive: !0 })),
        t.forEach(function (e) {
          window.addEventListener("load", (t) => {
            lazySizes.loader.unveil(e);
          });
        });
    }
    enableSwatches(e, t) {
      let i = e.querySelectorAll(".product-card-swatch"),
        s = t ? t.dataset.srcset : "";
      (this.color_index = this.swatches.dataset.index),
        i.forEach((e, a) => {
          window.addEventListener("load", (t) => {
            let i = new Image();
            (i.srcset = e.dataset.srcset), lazySizes.loader.unveil(i);
          }),
            e.addEventListener("mouseover", () => {
              [].forEach.call(i, function (e) {
                e.classList.remove("active");
              }),
                t &&
                  (e.dataset.srcset
                    ? t.setAttribute("srcset", e.dataset.srcset)
                    : t.setAttribute("srcset", s)),
                this.size_options &&
                  ((this.current_options[this.color_index] =
                    e.querySelector("span").innerText),
                  this.updateMasterId()),
                e.classList.add("active");
            }),
            e.addEventListener("click", function (e) {
              (window.location.href = this.dataset.href), e.preventDefault();
            });
        });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener("click", this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let e = this.size_options.querySelectorAll(".product-card-sizes--size"),
        t = this.querySelector(".product-featured-image"),
        i = t.classList.contains("thb-hover"),
        s = this.size_options.parentElement;
      (this.size_index = this.size_options.dataset.index),
        (this.current_options = this.size_options.dataset.options.split(",")),
        this.updateMasterId(),
        s.addEventListener(
          "mouseenter",
          () => {
            i && t.classList.remove("thb-hover");
          },
          { passive: !0 }
        ),
        s.addEventListener(
          "mouseleave",
          () => {
            i && t.classList.add("thb-hover");
          },
          { passive: !0 }
        ),
        e.forEach((e) => {
          e.addEventListener("click", (t) => {
            if ((t.preventDefault(), e.classList.contains("is-disabled")))
              return;
            (this.current_options[this.size_index] =
              e.querySelector("span").innerText),
              this.updateMasterId(),
              e.classList.add("loading"),
              e.setAttribute("aria-disabled", !0);
            let i = {
                method: "POST",
                headers: {
                  "X-Requested-With": "XMLHttpRequest",
                  Accept: "application/javascript",
                },
              },
              s = new FormData();
            s.append("id", this.currentVariant.id),
              s.append("quantity", 1),
              s.append(
                "sections",
                this.getSectionsToRender().map((e) => e.section)
              ),
              s.append("sections_url", window.location.pathname),
              (i.body = s),
              fetch(`${theme.routes.cart_add_url}`, i)
                .then((e) => e.json())
                .then((e) => {
                  !e.status &&
                    (this.renderContents(e),
                    dispatchCustomEvent("cart:item-added", {
                      product: e.hasOwnProperty("items") ? e.items[0] : e,
                    }));
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  e.classList.remove("loading"),
                    e.removeAttribute("aria-disabled");
                });
          });
        });
    }
    updateMasterId() {
      (this.currentVariant = this.getVariantData().find(
        (e) =>
          !e.options.map((e, t) => this.current_options[t] === e).includes(!1)
      )),
        setTimeout(() => {
          this.setDisabled();
        }, 100);
    }
    getVariantData() {
      return (
        (this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          )),
        this.variantData
      );
    }
    setDisabled() {
      let e = this.getVariantData();
      if (e) {
        if (this.currentVariant) {
          let t = this.currentVariant.options.map((e, t) => ({
              value: e,
              index: `option${t + 1}`,
            })),
            i = this.createAvailableOptionsTree(e, t),
            s = Object.values(i)[this.size_index];
          s &&
            this.size_options.querySelectorAll(".product-card-sizes--size")
              .length &&
            this.size_options
              .querySelectorAll(".product-card-sizes--size")
              .forEach((e, t) => {
                e.classList.toggle("is-disabled", s[t].isUnavailable);
              });
        } else
          this.size_options.querySelectorAll(".product-card-sizes--size")
            .length &&
            this.size_options
              .querySelectorAll(".product-card-sizes--size")
              .forEach((e, t) => {
                e.classList.add("is-disabled");
              });
      }
      return !0;
    }
    createAvailableOptionsTree(e, t) {
      return e.reduce(
        (e, i) => (
          Object.keys(e).forEach((s) => {
            if (null === i[s]) return;
            let a = e[s].find((e) => e.value === i[s]);
            void 0 === a &&
              ((a = { value: i[s], isUnavailable: !0 }), e[s].push(a));
            let n = t.reduce(
              (e, { value: t, index: s }) => (i[s] === t ? e + 1 : e),
              0
            );
            n >= t.length - 1 &&
              (a.isUnavailable =
                (!a.isUnavailable || !i.available) && a.isUnavailable),
              (!this.currentVariant || !this.currentVariant.available) &&
                t.find((e) => e.value === a.value && s === e.index) &&
                (a.isUnavailable = !0),
              "option1" === s &&
                (a.isUnavailable =
                  (!a.isUnavailable || !i.available) && a.isUnavailable);
          }),
          e
        ),
        { option1: [], option2: [], option3: [] }
      );
    }
    quickAdd(e) {
      if ((e.preventDefault(), this.quick_add.disabled)) return;
      this.quick_add.classList.add("loading"),
        this.quick_add.setAttribute("aria-disabled", !0);
      let t = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        },
        i = new FormData();
      return (
        i.append("id", this.quick_add.dataset.productId),
        i.append("quantity", 1),
        i.append(
          "sections",
          this.getSectionsToRender().map((e) => e.section)
        ),
        i.append("sections_url", window.location.pathname),
        (t.body = i),
        fetch(`${theme.routes.cart_add_url}`, t)
          .then((e) => e.json())
          .then((e) => {
            !e.status &&
              (this.renderContents(e),
              dispatchCustomEvent("cart:item-added", {
                product: e.hasOwnProperty("items") ? e.items[0] : e,
              }));
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.quick_add.classList.remove("loading"),
              this.quick_add.removeAttribute("aria-disabled");
          }),
        !1
      );
    }
    getSectionsToRender() {
      return [
        { id: "Cart", section: "main-cart", selector: ".thb-cart-form" },
        { id: "Cart-Drawer", section: "cart-drawer", selector: ".side-panel-content" },
        { id: "Cart-Drawer", section: "cart-drawer", selector: ".side-panel-footer" },
        {
          id: "cart-drawer-toggle",
          section: "cart-bubble",
          selector: ".thb-item-count",
        },
      ];
    }
    renderContents(e) {
      this.getSectionsToRender().forEach((t) => {
        if (!document.getElementById(t.id)) return;
        let i =
          document.getElementById(t.id).querySelector(t.selector) ||
          document.getElementById(t.id);
        (i.innerHTML = this.getSectionInnerHTML(
          e.sections[t.section],
          t.selector
        )),
          void 0 !== CartDrawer && new CartDrawer(),
          "undefined" != typeof Cart && new Cart().renderContents(e);
      }),
        document.getElementById("Cart-Drawer") &&
          (document.getElementById("Cart-Drawer").classList.add("active"),
          document.body.classList.add("open-cart"),
          document.body.classList.add("open-cc"),
          document
            .getElementById("Cart-Drawer")
            .querySelector(".product-recommendations--full") &&
            document
              .getElementById("Cart-Drawer")
              .querySelector(".product-recommendations--full")
              .classList.add("active"),
          dispatchCustomEvent("cart-drawer:open"));
    }
    getSectionInnerHTML(e, t = ".shopify-section") {
      return new DOMParser().parseFromString(e, "text/html").querySelector(t)
        .innerHTML;
    }
  }
  customElements.define("product-card", t);
}
if (!customElements.get("side-panel-close")) {
  class i extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.cc = document.querySelector(".click-capture")),
        (this.onClick = (e) => {
          let t = document.querySelectorAll(".side-panel.active");
          t.length && this.close_panel(e, t[0]);
        }),
        this.addEventListener("click", this.onClick.bind(this)),
        document.addEventListener("panel:close", this.onClick.bind(this)),
        this.cc.hasAttribute("initialized") ||
          (this.cc.addEventListener("click", this.onClick.bind(this)),
          this.cc.setAttribute("initialized", ""));
    }
    close_panel(e, t) {
      e && e.preventDefault(),
        (t || (t = e?.target.closest(".side-panel.active"))) &&
          (t.classList.contains("product-drawer") ||
          document.body.classList.contains("open-quick-view")
            ? this.close_quick_view()
            : t.classList.contains("cart-drawer")
            ? (t.querySelector(".product-recommendations--full") &&
                !document.body.classList.contains("open-quick-view") &&
                t
                  .querySelector(".product-recommendations--full")
                  .classList.remove("active"),
              window.innerWidth < 1069
                ? document.body.classList.contains("open-quick-view")
                  ? this.close_quick_view()
                  : (t.classList.remove("active"),
                    document.body.classList.remove("open-cc"),
                    document.body.classList.remove("open-cart"))
                : t.querySelector(".product-recommendations--full")
                ? document.body.classList.contains("open-quick-view")
                  ? this.close_quick_view()
                  : setTimeout(() => {
                      t.classList.remove("active"),
                        document.body.classList.remove("open-cc"),
                        document.body.classList.remove("open-cart");
                    }, 500)
                : (t.classList.remove("active"),
                  document.body.classList.remove("open-cc"),
                  document.body.classList.remove("open-cart")))
            : (t.classList.remove("active"),
              document.body.classList.remove("open-cc")));
    }
    close_quick_view() {
      let e = document.getElementById("Product-Drawer");
      e.querySelector(".product-quick-images--container") &&
        e
          .querySelector(".product-quick-images--container")
          .classList.remove("active"),
        window.innerWidth < 1069
          ? (e.classList.remove("active"),
            (document.body.classList.contains("open-cart") &&
              document.body.classList.contains("open-quick-view")) ||
              document.body.classList.remove("open-cc"),
            document.body.classList.remove("open-quick-view"))
          : e.querySelector(".product-quick-images--container") &&
            setTimeout(() => {
              e.classList.remove("active"),
                (document.body.classList.contains("open-cart") &&
                  document.body.classList.contains("open-quick-view")) ||
                  document.body.classList.remove("open-cc"),
                document.body.classList.remove("open-quick-view"),
                (e.querySelector("#Product-Drawer-Content").innerHTML = "");
            }, 500);
    }
  }
  customElements.define("side-panel-close", i),
    document.addEventListener("keyup", (e) => {
      e.code &&
        "ESCAPE" === e.code.toUpperCase() &&
        dispatchCustomEvent("panel:close");
    });
}
class CartDrawer {
  constructor() {
    if (
      ((this.container = document.getElementById("Cart-Drawer")),
      !this.container)
    )
      return;
    let e = document.getElementById("cart-drawer-toggle");
    this.container.querySelectorAll(".quantity input"),
      e.addEventListener("click", (e) => {
        e.preventDefault(),
          document.body.classList.add("open-cc"),
          document.body.classList.add("open-cart"),
          this.container.classList.add("active"),
          this.container.focus(),
          setTimeout(() => {
            this.container.querySelector(".product-recommendations--full") &&
              this.container
                .querySelector(".product-recommendations--full")
                .classList.add("active");
          }),
          dispatchCustomEvent("cart-drawer:open");
      }),
      (this.debouncedOnChange = debounce((e) => {
        this.onChange(e);
      }, 300)),
      document.addEventListener("cart:refresh", (e) => {
        this.refresh();
      }),
      this.container.addEventListener(
        "change",
        this.debouncedOnChange.bind(this)
      ),
      this.notesToggle(),
      this.removeProductEvent(),
      this.updateFreeShipping();
  }
  onChange(e) {
    e.target.classList.contains("qty") &&
      this.updateQuantity(e.target.dataset.index, e.target.value);
  }
  removeProductEvent() {
    this.container.querySelectorAll(".remove").forEach((e) => {
      e.addEventListener("click", (e) => {
        this.updateQuantity(e.target.dataset.index, "0"), e.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [
      { id: "Cart-Drawer", section: "cart-drawer", selector: ".side-panel-content" },
      { id: "Cart-Drawer", section: "cart-drawer", selector: ".side-panel-footer" },
      {
        id: "cart-drawer-toggle",
        section: "cart-bubble",
        selector: ".thb-item-count",
      },
    ];
  }
  getSectionInnerHTML(e, t) {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t)
      .innerHTML;
  }
  notesToggle() {
    let e = document.getElementById("order-note-toggle");
    e &&
      (e.addEventListener("click", (t) => {
        e.nextElementSibling.classList.add("active");
      }),
      e.nextElementSibling
        .querySelectorAll(".button, .order-note-toggle__content-overlay")
        .forEach((t) => {
          t.addEventListener("click", (t) => {
            e.nextElementSibling.classList.remove("active"), this.saveNotes();
          });
        }));
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        note: document.getElementById("mini-cart__notes").value,
      }),
    });
  }
  updateFreeShipping() {
    let e = this.container.querySelector(".free-shipping");
    if (e) {
      let t = e.querySelector(".free-shipping--text span"),
        i = parseInt(e.dataset.cartTotal, 10),
        s = Math.round(
          parseInt(e.dataset.minimum, 10) * (Shopify.currency.rate || 1)
        ),
        a = 1;
      if (i < s && ((a = i / s), t)) {
        let n =
          window.theme.settings.money_with_currency_format || "${{amount}}";
        t.innerHTML = formatMoney(s - i, n);
      }
      e.style.setProperty("--percentage", a);
    }
  }
  updateQuantity(e, t) {
    this.container
      .querySelector(`#CartDrawerItem-${e}`)
      ?.classList.add("thb-loading");
    let i = JSON.stringify({
      line: e,
      quantity: t,
      sections: this.getSectionsToRender().map((e) => e.section),
      sections_url: window.location.pathname,
    });
    dispatchCustomEvent("line-item:change:start", { quantity: t }),
      this.container.querySelector(".product-recommendations--full") &&
        this.container
          .querySelector(".product-recommendations--full")
          .classList.remove("active"),
      fetch(`${theme.routes.cart_change_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: i,
      })
        .then((e) => e.text())
        .then((i) => {
          let s = JSON.parse(i);
          this.getSectionsToRender().forEach((e) => {
            let t =
              document.getElementById(e.id).querySelector(e.selector) ||
              document.getElementById(e.id);
            s.sections &&
              (t.innerHTML = this.getSectionInnerHTML(
                s.sections[e.section],
                e.selector
              ));
          }),
            this.removeProductEvent(),
            this.notesToggle(),
            this.updateFreeShipping(),
            dispatchCustomEvent("line-item:change:end", {
              quantity: t,
              cart: s,
            }),
            this.container.querySelector(`#CartDrawerItem-${e}`) &&
              this.container
                .querySelector(`#CartDrawerItem-${e}`)
                .classList.remove("thb-loading");
        });
  }
  refresh() {
    this.container.querySelector(".product-recommendations--full") &&
      this.container
        .querySelector(".product-recommendations--full")
        .classList.remove("active"),
      fetch(`${window.location.pathname}?sections=cart-drawer,cart-bubble`)
        .then((e) => e.text())
        .then((e) => {
          let t = JSON.parse(e);
          this.getSectionsToRender().forEach((e) => {
            let i =
              document.getElementById(e.id).querySelector(e.selector) ||
              document.getElementById(e.id);
            i.innerHTML = this.getSectionInnerHTML(t[e.section], e.selector);
          }),
            this.removeProductEvent(),
            this.notesToggle(),
            this.updateFreeShipping();
        });
  }
}
class SelectWidth {
  constructor() {
    let e = this;
    window.addEventListener("load", () => {
      document.querySelectorAll(".resize-select").forEach(e.resizeSelect);
    }),
      document.body.addEventListener("change", (t) => {
        t.target.matches(".resize-select") &&
          null !== t.target.offsetParent &&
          e.resizeSelect(t.target);
      }),
      window.addEventListener("resize.resize-select", function () {
        document.querySelectorAll(".resize-select").forEach(e.resizeSelect);
      });
  }
  resizeSelect(e) {
    let t = document.createElement("option");
    t.textContent = e.selectedOptions[0].textContent;
    let i = document.createElement("select"),
      s = 13;
    (i.style.visibility = "hidden"),
      (i.style.position = "fixed"),
      i.appendChild(t),
      (e.classList.contains("thb-language-code") ||
        e.classList.contains("thb-currency-code") ||
        e.classList.contains("facet-filters__sort")) &&
        (s = 2),
      e.after(i),
      i.clientWidth > 0 && (e.style.width = `${+i.clientWidth + s}px`),
      i.remove();
  }
}
new SelectWidth();
class FooterMenuToggle {
  constructor() {
    document.querySelectorAll(".thb-widget-title.collapsible").forEach((e) => {
      e.addEventListener("click", (t) => {
        e.classList.toggle("active");
      });
    });
  }
}
if (!customElements.get("quick-view")) {
  class s extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.drawer = document.getElementById("Product-Drawer")),
        (this.body = document.body),
        this.addEventListener("click", this.setupEventListener.bind(this));
    }
    setupEventListener(e) {
      e.preventDefault();
      let t = this.dataset.productHandle,
        i = `${theme.routes.root_url}/products/${t}?view=quick-view`;
      !(
        !(i = i.replace("//", "/")) ||
        !t ||
        this.classList.contains("loading")
      ) &&
        (this.classList.add("loading"),
        fetch(i, { method: "GET" })
          .then((e) => (this.classList.remove("loading"), e.text()))
          .then((e) => {
            let s = new DOMParser()
              .parseFromString(e, "text/html")
              .querySelector("#Product-Drawer-Content").innerHTML;
            this.renderQuickview(s, i, t);
          }));
    }
    renderQuickview(e, t, i) {
      if (e) {
        this.drawer.querySelector("#Product-Drawer-Content").innerHTML = e;
        let s = this.drawer
          .querySelector("#Product-Drawer-Content")
          .querySelectorAll("script");
        if (s.length > 0) {
          var a = document.getElementsByTagName("head")[0];
          s.forEach((e, t) => {
            let i = document.createElement("script");
            (i.src = e.src), a.appendChild(i);
          });
        }
        setTimeout(() => {
          Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
            window.ProductModel && window.ProductModel.loadShopifyXR();
        }, 300),
          this.body.classList.add("open-cc"),
          this.body.classList.add("open-quick-view"),
          this.drawer.classList.add("active"),
          this.drawer.querySelector(".side-panel-close").focus(),
          setTimeout(() => {
            this.drawer
              .querySelector(".product-quick-images--container")
              .classList.add("active");
          }),
          dispatchCustomEvent("quick-view:open", {
            productUrl: t,
            productHandle: i,
          }),
          addIdToRecentlyViewed(i);
      }
    }
  }
  customElements.define("quick-view", s);
}
if (!customElements.get("side-panel-content-tabs")) {
  class a extends HTMLElement {
    constructor() {
      super(),
        (this.buttons = this.querySelectorAll("button")),
        (this.panels = this.parentElement.querySelectorAll(
          ".side-panel-content--tab-panel"
        ));
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {}
    setupButtonObservers() {
      this.buttons.forEach((e, t) => {
        e.addEventListener("click", (e) => {
          this.toggleActiveClass(t);
        });
      });
    }
    toggleActiveClass(e) {
      this.buttons.forEach((e) => {
        e.classList.remove("tab-active");
      }),
        this.buttons[e].classList.add("tab-active"),
        this.panels.forEach((e) => {
          e.classList.remove("tab-active");
        }),
        this.panels[e].classList.add("tab-active");
    }
  }
  customElements.define("side-panel-content-tabs", a);
}
if (!customElements.get("collapsible-row")) {
  class n extends HTMLElement {
    constructor() {
      super(),
        (this.details = this.querySelector("details")),
        (this.summary = this.querySelector("summary")),
        (this.content = this.querySelector(".collapsible__content")),
        (this.animation = null),
        (this.isClosing = !1),
        (this.isExpanding = !1);
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector("summary").addEventListener("click", (e) =>
        this.onClick(e)
      );
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      e.preventDefault(),
        (this.details.style.overflow = "hidden"),
        this.isClosing || !this.details.open
          ? this.open()
          : (this.isExpanding || this.details.open) && this.shrink();
    }
    shrink() {
      this.isClosing = !0;
      let e = `${this.details.offsetHeight}px`,
        t = `${this.summary.offsetHeight}px`;
      this.animation && this.animation.cancel(),
        (this.animation = this.details.animate(
          { height: [e, t] },
          { duration: 250, easing: "ease" }
        )),
        (this.animation.onfinish = () => this.onAnimationFinish(!1)),
        (this.animation.oncancel = () => (this.isClosing = !1));
    }
    open() {
      (this.details.style.height = `${this.details.offsetHeight}px`),
        (this.details.open = !0),
        window.requestAnimationFrame(() => this.expand());
    }
    expand() {
      this.isExpanding = !0;
      let e = `${this.details.offsetHeight}px`,
        t = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      this.animation && this.animation.cancel(),
        (this.animation = this.details.animate(
          { height: [e, t] },
          { duration: 400, easing: "ease-out" }
        )),
        (this.animation.onfinish = () => this.onAnimationFinish(!0)),
        (this.animation.oncancel = () => (this.isExpanding = !1));
    }
    onAnimationFinish(e) {
      (this.details.open = e),
        (this.animation = null),
        (this.isClosing = !1),
        (this.isExpanding = !1),
        (this.details.style.height = this.details.style.overflow = "");
    }
  }
  customElements.define("collapsible-row", n);
}
function addIdToRecentlyViewed(e) {
  if (!e) {
    let t = document.querySelector(".thb-product-detail");
    t && (e = t.dataset.handle);
  }
  if (e) {
    if (window.localStorage) {
      let i = window.localStorage.getItem("recently-viewed");
      "undefined" != i &&
        null != i &&
        (window.recentlyViewedIds = JSON.parse(i));
    }
    var s = window.recentlyViewedIds.indexOf(e);
    s > -1 && window.recentlyViewedIds.splice(s, 1),
      window.recentlyViewedIds.unshift(e),
      window.localStorage &&
        window.localStorage.setItem(
          "recently-viewed",
          JSON.stringify(window.recentlyViewedIds)
        );
  }
}
document.addEventListener("DOMContentLoaded", () => {
  new CartDrawer(), new FooterMenuToggle();
});
